import React, { Component } from "react";
import ShowCorresponseProvider from "../common/timeline";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { fetchRequest } from "../../../services/insurance/requestHistory";
import { getAge, getDateObj } from "../../../services/insurance/common";
import { USER } from "../../../constants/insurance/constant";
import { MaskElement } from "../../../services/insurance/common";
import { communicationHistory, getDownloadEmail } from "../../../services/insurance/correspondence";
import ShowCommunicationHistory from "../dialogs/communication-history";
import { showCorrespondence } from "../../../services/insurance/correspondence"
import ArrowLeftOutlinedIcon from '@mui/icons-material/ArrowBackTwoTone';

import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ChatIcon from '@mui/icons-material/Chat';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Tooltip from '@mui/material/Tooltip';
import { InsurerErIDs } from "../../../constants/provider/constant";
class EsalesHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      esaleId: this.props.match.params.esaleId ? this.props.match.params.esaleId : null,
      historyDetails: null,
      dcLogin: USER.user && USER.user.roleId && USER.user.roleId === 5432 ? true : false,
      communicationHistory: "",
      showCommunicationModal: false,
    }
  }

  componentDidMount() {
    console.log("esaleId", this.state.esaleId)
    if (this.state.esaleId != null && this.state.history == null) {
      this.getHistory();
    }
  }

  getCommHistory = () => {
    communicationHistory(this.state.esaleId).then(res => {
      this.setState({ communicationHistory: this.getCountObject(res.communicationDetails) })
    })
  }
  getCountObject = (data) => {
    let obj = {};
    data.map(ele => {
      if (obj[ele.communicationTypeValue])
        obj[ele.communicationTypeValue] += 1
      else
        obj[ele.communicationTypeValue] = 1;
    });
    return obj;
  }
  getHistory() {
    fetchRequest(this.state.esaleId).then(response => {
      console.log("response.data", response)
      if (response && response.isSuccess) {
        this.setState({
          requestDetails: response,
        });
        this.showCorrespondence();
        this.getDetails();
        this.getCommHistory();
      }
      else {
        this.props.history.push('/insureradmin/appointments');
      }
    })
  }
  showCorrespondence() {
    showCorrespondence(this.state.esaleId).then(response => {
      if (response && response.isSuccess) {
        this.setState({
          statusHistory: [{
            statusId: 0,
            status: "Esales",
            date: this.state.requestDetails.queueRequests.queueList[0].dateTimeCreated,
            remarks: "From Esales",
            createdBy: 0,
            correspondences: response.correspondences
          }]
        });
      }
    })
  }

  getDetails() {
    if (this.state.requestDetails && this.state.requestDetails.queueRequests.queueList != null) {

      let customerDetails = {
        patientName: this.state.requestDetails.queueRequests.queueList[0].requestJSON.name || '--',
        gender: this.state.requestDetails.queueRequests.queueList[0].gender || '--',
        age: getAge(this.state.requestDetails.queueRequests.queueList[0].requestJSON.additionals.DOB),
        employeeID: this.state.requestDetails.queueRequests.queueList[0].requestJSON.employeeId || '--',
        employeeMailID: this.state.requestDetails.queueRequests.queueList[0].displayEmail || '--',
        contactNo: this.state.requestDetails.queueRequests.queueList[0].displayPhone || '--',
        addressLine1: this.state.requestDetails.queueRequests.queueList[0].requestJSON.addressLine1 | '--',
        addressLine2: this.state.requestDetails.queueRequests.queueList[0].requestJSON.addressLine2 || '--',
        isHNI: this.state.requestDetails.queueRequests.queueList[0].requestJSON.additionals.PriorityName === 'HNI' ? true : false,
        isSHNI: this.state.requestDetails.queueRequests.queueList[0].requestJSON.additionals.PriorityName === 'SHNI' ? true : false,
        isDND: this.state.requestDetails.queueRequests.queueList[0].dnd || this.state.requestDetails.queueRequests.queueList[0].dndForCustomers || false
      }

      let caseDetails = {
        TestDetails: this.state.requestDetails.queueRequests.queueList[0].requestJSON.testDetails.map(ele => {
          return ele.testName
        }).join(','),
        Source: this.state.requestDetails.queueRequests.queueList[0].source || '--',
        InsurerName: this.state.requestDetails.queueRequests.queueList[0].corporateName || '--',
      }

      this.setState({
        customerDetails: customerDetails,
        caseDetails: caseDetails,
        statusHistory: this.state.esaleCorrespondences
      })
    }
  }

  renderCustomerDetails() {
    return (
      <div>
        {this.state.customerDetails ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-brown rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Customer Details
                <div className="h-px mt-1"></div>
              </div>
              <div>
                <div> <span className="text-gray-400 text-sm">Patient Name :</span>
                  <div>
                    {this.state.customerDetails.patientName}
                  </div>
                </div>

                <div> <span className="text-gray-400 text-sm">Email Id:</span>
                  <div>
                    {MaskElement(this.state.customerDetails.employeeMailID, { DND: this.state.customerDetails.isDND })}
                  </div>
                </div>

                <div> <span className="text-gray-400 text-sm">Contact No :</span>
                  <div>
                    {MaskElement(this.state.customerDetails.contactNo, { DND: this.state.customerDetails.isDND })}
                  </div>
                </div>
                <div>
                  <div>
                    <span className="text-gray-400 text-sm"> Member Id / MAID : </span>
                    <div>
                      {this.state.customerDetails.employeeID}</div>
                  </div>
                </div>
                <div> <span className="text-gray-400 text-sm"> Employee ID : </span>
                  <div>
                    {this.state.customerDetails.employeeID}</div>
                </div>
                {this.state.customerDetails.isHNI ? <div>
                  <span className="text-gray-400 text-sm"> HNI: </span>
                  <div>
                    {this.state.customerDetails.isHNI ? 'YES' : 'NO'}
                  </div>
                </div> : this.state.customerDetails.isSHNI ?
                  <div>
                    <span className="text-gray-400 text-sm"> SHNI: </span>
                    <div>
                      {this.state.customerDetails.isSHNI ? 'YES' : 'NO'}
                    </div>
                  </div> : ''}

                {this.state.customerDetails.isDND ?
                  <div>
                    <span className="text-gray-400 text-sm"> DND: </span>
                    <div>
                      YES
                    </div>
                  </div> : ''
                }
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }


  renderCaseDetails() {
    return (
      <div>
        {this.state.caseDetails ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-blue rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold relative">
                <button
                  style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)' }}
                  onClick={() => this.props.history.goBack()}
                  className="back-btn p-2 font-bold text-gray-900 border-2 border-gray-800 bg-gray-100 rounded-full"
                >
                  <ArrowLeftOutlinedIcon />
                </button>
                Case Details
                <div className="h-px mt-1"></div>
              </div>
              <div>
                <div> <span className="text-gray-400 text-sm">Test Categories :</span>
                  <div>
                    {this.state.caseDetails.TestDetails}
                  </div>
                </div>
                <div> <span className="text-gray-400 text-sm">Insurer Name:</span>
                  <div>
                    {this.state.caseDetails.InsurerName}</div>
                </div>


                <div>
                  <span className="text-gray-400 text-sm">Source : </span>
                  <div>
                    {this.state.caseDetails.Source}</div>
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }

  renderAdditionals() {
    return (
      <div>
        {this.state.requestDetails && this.state.requestDetails?.queueRequests?.queueList[0]?.requestJSON?.additionals ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-blue rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Additional Info
                <div className="h-px mt-1"></div>
              </div>
              <div>

                {/* Dynamic fields from additionals */}
                <div className="mt-4">
                  {Object.entries(this.state.requestDetails?.queueRequests?.queueList[0]?.requestJSON?.additionals).map(
                    ([key, value]) => (
                      <div key={key} className="mt-2">
                        <span className="text-gray-400 text-sm">{key}:</span>
                        <div>{String(value)}</div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }

  showIcon = (icon) => {
    switch (icon) {
      case "sms":
        return { icon: <ChatIcon></ChatIcon>, type: "SMS" }
        break;
      case "email":
        return { icon: <EmailIcon></EmailIcon>, type: "Email" }
        break;
      case "whatsapp":
        return { icon: <WhatsAppIcon></WhatsAppIcon>, type: "WhatsApp" }
        break;
      case "call":
        return { icon: <CallIcon></CallIcon>, type: "Call" }
        break;
      default:
        return { icon: <HeadsetMicIcon></HeadsetMicIcon>, type: "Others" }
        break;
    }
  }

  render() {
    return (
      <Box sx={{ flexGrow: 1, minHeight: '100vh' }}>
        <Grid container className="p-4" spacing={2}>
          <Grid item xs={12} md={4}>

            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
              <CardContent style={{ padding: '0px' }}>
                {
                  this.state.customerDetails && this.state.customerDetails.isDND ?
                    <div className="flex justify-center float-right bg-gray-100 rounded text-xs p-1 rounded-lg">
                      <div className="text-red-500"><DoNotDisturbIcon></DoNotDisturbIcon></div>
                      <div className="px-2 m-auto font-semibold">
                        DO NOT DISTURB
                      </div>
                    </div> : ''
                }
                {this.renderCaseDetails()}
              </CardContent>
            </Card>

            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }} >
              <CardContent style={{ padding: '0px' }}>
                {
                  this.state.communicationHistory && Object.keys(this.state.communicationHistory).length != 0 &&
                  <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-blue rounded-xl">
                    <div>
                      <div className="w-full text-left pb-2  text-sm font-bold">
                        Communication:
                        <div className="h-px mt-1"></div>
                      </div>
                      <div className="flex" >
                        {
                          Object.keys(this.state.communicationHistory).map(ele => {
                            const a = InsurerErIDs[ele.toLowerCase()];
                            if (a && a.includes(this.state.primaryEntityId)) {
                              return null;
                            }
                            let icon = this.showIcon(ele.toLowerCase())
                            return (
                              <div onClick={() => this.setState({ showCommunicationModal: true })} className=" cursor-pointer border border-gray-500 text-gray-200 font-semibold text-center rounded-3xl shadow-inner text-sm cursor-pointer mr-1 h-full">
                                <Tooltip title={icon.type}>
                                  <div className="p-1 mx-1">
                                    <span className="mr-2">
                                      {icon.icon}
                                    </span>
                                    <span className="text-blue-800	font-bold rounded-3xl px-1 bg-gray-300 text-sm">
                                      {this.state.communicationHistory[ele]}
                                    </span>
                                  </div>
                                </Tooltip>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                }
              </CardContent>
            </Card>

            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
              <CardContent style={{ padding: '0px' }}>
                {
                  this.state.customerDetails && this.state.customerDetails.isDND ?
                    <div className="flex justify-center float-right bg-gray-100 rounded text-xs p-1 rounded-lg">
                      <div className="text-red-500"><DoNotDisturbIcon></DoNotDisturbIcon></div>
                      <div className="px-2 m-auto font-semibold">
                        DO NOT DISTURB
                      </div>
                    </div> : ''
                }
                {this.renderCustomerDetails()}
              </CardContent>
            </Card>

            {this.state.requestDetails && this.state.requestDetails?.queueRequests?.queueList[0]?.requestJSON?.additionals ?
              <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
                <CardContent style={{ padding: '0px' }}>
                  {this.renderAdditionals()}
                </CardContent>
              </Card>
              : ''}

          </Grid>

          <Grid item xs={12} md={8}>
            {
              this.state.statusHistory && this.state.statusHistory.length > 0 ? <ShowCorresponseProvider statusHistory={this.state.statusHistory}></ShowCorresponseProvider> : ''
            }
          </Grid>
        </Grid>

        <Dialog
          open={this.state.showCommunicationModal}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ showCommunicationModal: false })
            } else return false;
          }}
          fullWidth={true}
          maxWidth={'md'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ background: "rgb(245 245 245)" }}>
            <div className="flex justify-between">
              <div className="font-semibold">
                <span className="cursor-pointer">
                  Communication History
                </span>
                {
                  this.state.esaleId ?
                    <div className="text-xs text-gray-500">
                      Request ID <span className="font-semibold">{this.state.esaleId} </span>
                    </div> : <></>
                }

              </div>
              <div className="text-gray-500" onClick={() => this.setState({ showCommunicationModal: false })}>
                <span className="cursor-pointer">
                  <CloseIcon></CloseIcon>
                </span>
              </div>
            </div>

          </DialogTitle>
          <DialogContent>
            <ShowCommunicationHistory details={{ id: this.state.esaleId }}></ShowCommunicationHistory>
          </DialogContent>
        </Dialog>

      </Box>

    )
  }
}
export default EsalesHistory;
